import { useEffect, useRef } from "react";

import "./Loader.scss";

export default function Loader() {
  const loaderEl = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      loaderEl.current.classList.add("hidden");
    }, 2000);
  });
  return (
    <div className="loader" ref={loaderEl}>
      <div className="loader__text">Loading...</div>
      <div className="loader__spinner">
        <div className="bar bar-1"></div>
        <div className="bar bar-2"></div>
        <div className="bar bar-3"></div>
        <div className="bar bar-4"></div>
      </div>
    </div>
  );
}
